let seq = 0;

export class ToolboxButton {
    constructor() {
        this.icon = "";
        this.iconTransform = "";

        this.label = "";
        this.variant = "plm-toolbar-secondary";
        /** @type {function(ToolboxButton)} */
        this.action = function(){};

        /** @type {function(boolean)} */
        this.toggle = function(toggled){};
        this.id = seq++;
        this.onSidebar = false;
        this.onHeadbar = true;
        this.group = "";
        this.disabled = false;
        this.visible = true;
        this.type = 'default';
        this.toggled = false;
        this.dataTestPath = ''
        this.requiredPermission = null;
        this.text = "";
        this.noIcon = false;
        this.customClass = null;
    }

    withGroup(val){
        this.group = val;
        return this;
    }

    withNoIcon() {
        this.noIcon = true;
        return this;
    }

    withText(val) {
        this.text = val;
        return this;
    }

    withCustomClass(val) {
        this.customClass = val;
        return this;
    }

    setToggleType(){
        this.type = 'toggle';
        return this;
    }

    withDataTestPath(val) {
        this.dataTestPath = val;
        return this;
    }

    withToggled(toggled){
        this.toggled = toggled;
        return this;
    }

    withIcon(val){
        this.icon = val;
        return this;
    }
    withIconTransform(val){
        this.iconTransform = val;
        return this;
    }
    withLabel(val){
        this.label = val;
        return this;
    }
    withVariant(val){
        this.variant = val;
        return this;
    }
    withAction(val){
        this.action = val;
        return this;
    }
    withToggle(val){
        this.toggle = val;
        return this;
    }
    withVisible(val){
        this.visible = val;
        return this;
    }
    withDisabled(val){
        this.disabled = val;
        return this;
    }
    withRequiredPermission(val){
        this.requiredPermission = val;
        return this;
    }

    execute(btn){
        this.action(btn);
    }
}
